export function InfoGrid({ name, value }: { name: string; value: any }) {
  if (!value) return <></>;
  return (
    <div className="infoGrid">
      <div className="gray">{name}</div>
      <div className="bold">{value}</div>
    </div>
  );
}
